import classnames from 'classnames';
import noop from 'lodash/noop';
import * as React from 'react';

export type CheckboxChangeHandler = (
  checked: boolean,
  evt: React.SyntheticEvent
) => void;

interface Props {
  id?: string;
  checked: boolean;
  className?: string;
  indeterminate?: boolean;
  disabled: boolean;
  size: string;
  onChange: CheckboxChangeHandler;
}

class Checkbox extends React.Component<Props> {
  static defaultProps = {
    onChange: noop,
    indeterminate: false,
    disabled: false,
    size: 'regular',
  };

  handleClick = (evt: React.SyntheticEvent): void => {
    const { checked, onChange, disabled } = this.props;

    if (!disabled) {
      onChange(!checked, evt);
    }
  };

  render(): React.ReactNode {
    const { id, checked, className, indeterminate, disabled, size } =
      this.props;

    return (
      <div
        id={id}
        role="checkbox"
        aria-checked={checked}
        tabIndex={0}
        className={classnames(
          className,
          'component-checkbox',
          'cursor-pointer bgd-white',
          {
            'wrem-1p5 hrem-1p5 min-wrem-1p5': size === 'large',
            'ws1 hs1 min-wrem-1': size !== 'large',
          },
          {
            'cursor-pointer': !disabled,
            'cursor-not-allowed': disabled,
          }
        )}
        style={{
          opacity: disabled ? '0.25' : '1',
          borderRadius: '2px',
          border:
            checked || indeterminate
              ? 'solid 1px var(--color-primary)'
              : `solid 1px var(--color-gray-4)`,
        }}
        onClick={this.handleClick}
      >
        {checked || indeterminate ? (
          <div
            className="flex-center h100"
            style={{
              padding: '2px',
              backgroundColor: checked
                ? 'var(--color-primary-light)'
                : 'var(--color-primary-light)',
            }}
          >
            {checked ? (
              <svg
                className="checked h100"
                style={{ fill: 'var(--color-white)' }}
                viewBox="0 0 805 613"
              >
                <path d="M270,447.75l441,-441c9,-9 24,-9 33,0l54,54c9,9 9,24 0,33l-512,512c-9,9 -23,9 -32,0l-248,-248c-8,-8 -8,-23 0,-32l55,-54c9,-9 24,-9 32,0l177,176Z" />
              </svg>
            ) : (
              <svg
                className="indeterminate h100"
                viewBox="0 0 56 10"
                style={{ fill: 'var(--color-white)' }}
              >
                <g>
                  <rect x="0" y="0" width="55.996" height="9.991" />
                </g>
              </svg>
            )}
          </div>
        ) : null}
      </div>
    );
  }
}

export default Checkbox;
